import { useAuth } from 'hooks/useAuth';
import { getRestaurantPath, LOCATION_HOME, OVERVIEW } from 'scopes/nav';
import { useCanAccessNavItem } from 'hooks/useCanAccessNavItem';
import { LOCATION_HOME_PATH } from 'constants/path';

export function useGetLocationHomePath() {
  const { companies, isUserCubohAndChowNow, isUserCubohOnly, isUserChowNowOnly } = useAuth();
  const canAccessNavItem = useCanAccessNavItem();

  return locationId => {
    const restaurantPath = getRestaurantPath(isUserCubohOnly, locationId);

    // Location Home takes priority over every other landing destination below,
    // regardless of user/restaurant category.
    if (canAccessNavItem(LOCATION_HOME)) {
      return `${restaurantPath}/${LOCATION_HOME_PATH}`;
    }

    const canAccessOverview = canAccessNavItem(OVERVIEW);
    const getHomePage = hasOverview =>
      hasOverview ? `${restaurantPath}/overview` : `${restaurantPath}/orders`;

    // Mixed Cuboh+ChowNow users
    if (isUserCubohAndChowNow) {
      const isChowNowRestaurant = Object.values(companies).some(
        company => company.chownow_restaurant_id === locationId,
      );
      return isChowNowRestaurant ? getHomePage(canAccessOverview) : `${restaurantPath}/orders`;
    }

    // Cuboh-only or ChowNow-only users
    if (isUserCubohOnly || isUserChowNowOnly) {
      return getHomePage(canAccessOverview);
    }

    return restaurantPath;
  };
}
